import { useListPackages } from '@/features/packages/api';
import { usePackageEditor } from '@/features/packages/package-form';
import { BRANCH_PATHS } from '@/lib/route-paths';

import { registerEntityEditor } from '../registry';

registerEntityEditor({
  slug: 'package',
  listPath: BRANCH_PATHS.catalogPackages,
  use: ({ id }) => {
    // Edit mode resolves the record from the list the catalog already caches,
    // so opening the editor from the list is instant and does not refetch.
    const { packages, isLoading } = useListPackages();
    const pkg = id ? (packages.find((p) => p.id === id) ?? null) : null;

    const editor = usePackageEditor({ pkg });

    return {
      ...editor,
      isLoading: Boolean(id) && isLoading,
      notFound: Boolean(id) && !isLoading && !pkg,
    };
  },
});
